import { Box } from '@chakra-ui/react';

export function Divider() {
  return (
    <Box
      borderLeft="1px solid white"
      borderBottom="1px solid white"
      mx={{ base: 0, md: 4 }}
      my={{ base: 4, md: 0 }}
      h={{ base: 0, md: 'full' }}
      w={{ base: 'full', md: 0 }}
    />
  );
}
